import React, { useEffect, useState } from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { apiFetch } from '../utils/api';

const ProtectedAdminRoute = () => {
  const [isAdmin, setIsAdmin] = useState(null);
  const [loading, setLoading] = useState(true);
  const location = useLocation();

  useEffect(() => {
    const checkAdmin = async () => {
      const userEmail = localStorage.getItem('userEmail');
      if (!userEmail) {
        setIsAdmin(false);
        setLoading(false);
        return;
      }
      try {
        const data = await apiFetch(`${window._env_.API_BASE_URL}/users/info?email=${userEmail}`);
        setIsAdmin(data.is_admin === true);
      } catch (err) {
        setIsAdmin(false);
      } finally {
        setLoading(false);
      }
    };
    checkAdmin();
  }, [location.pathname]);

  if (loading) return null; // or a spinner
  if (!isAdmin) {
    sessionStorage.setItem('redirectAfterLogin', location.pathname + location.search);
    return <Navigate to="/Login" replace />;
  }
  return <Outlet />;
};

export default ProtectedAdminRoute;